import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import * as Sentry from "@sentry/react";
import { api, getCsrfToken } from "helpers/axios";
import { clearCookie, isUserCookie } from "helpers/cookie";
import { apiBaseUrl } from "helpers/runtimeConfig";
import { runPostLogin } from "helpers/postLogin";
import { useTranslation } from "translation/useTranslation";
import Banner from "components/ui/Banner";

// 422: token fails the backend size:64 rule, i.e. a mangled link.
const EXPECTED_ERROR_STATUSES = [403, 404, 419, 422];

export default function Impersonate() {
  const dispatch = useDispatch();
  const { editableTranslate } = useTranslation();
  const started = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    // The token is single-use, so StrictMode's second effect run must not redeem it again.
    if (started.current) return;
    started.current = true;

    const accountId = new URLSearchParams(window.location.search).get('accountId');
    const token = window.location.hash.slice(1);
    window.history.replaceState(null, '', '/impersonate');

    if (!accountId || !token) {
      setError(true);
      return;
    }

    const redeem = async () => {
      try {
        localStorage.removeItem('period');
        localStorage.removeItem('module');
        localStorage.removeItem('mode_scope');
        localStorage.setItem('accountId', accountId);
        sessionStorage.setItem('skip_autologin', '1');
        if (isUserCookie()) clearCookie();

        await getCsrfToken();
        const { data } = await api.post('/impersonate', { token }, { baseURL: apiBaseUrl });
        await runPostLogin(dispatch, data.data);
      } catch (err) {
        if (!EXPECTED_ERROR_STATUSES.includes(err?.response?.status)) {
          Sentry.captureException(err);
        }
        setError(true);
      }
    };
    redeem();
  }, []);

  return (
    <div className="container" data-testid="impersonate-page">
      <div className="login-div">
        {error ? (
          <Banner intent="danger" data-testid="impersonate-error">
            <div>{editableTranslate('global.impersonation.invalid', 'Der Link zur Identitätsübernahme ist ungültig oder abgelaufen.')}</div>
            <a href="/login?skip_autologin=1" data-testid="impersonate-error-login-link">
              {editableTranslate('global.impersonation.back_to_login', 'Zur Anmeldung')}
            </a>
          </Banner>
        ) : (
          <div className="text-center p-5" data-testid="impersonate-loading">
            <div className="spinner-border">
              <span className="sr-only">Wird geladen...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
